import { ChartOptions } from "chart.js";

export const websiteVisitLineOptions: ChartOptions<"line"> = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false
    },
    tooltip:
    {
      callbacks: {
        title: () => '', // Remove title
        label: (context) => {
          const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
          return `${months[context.dataIndex]} : ${context.parsed.y}`;
        }
      },
      displayColors: false, // This removes the color box
    }
  },
  scales: {
    x: {
      grid: {
        display: false,
      },
    },
    y: {
      beginAtZero: true,
      ticks: {
        stepSize: 25,
      },
    },
  },
  onHover: (event: any, chartElements: any) => {
    const canvas = event.native?.target;
    if (canvas) {
      if (chartElements && chartElements.length > 0) {
        canvas.style.cursor = 'pointer';
      } else {
        canvas.style.cursor = 'default';
      }
    }
  },
};
